/* Cybar Coffee theme: variant pills update price/button; thumbnails swap the main image; subscribe toggle. */
document.addEventListener('change', function (e) {
  var r = e.target.closest && e.target.closest('[data-variant-radio]');
  if (!r) return;
  var price = document.querySelector('[data-product-price]');
  if (price) price.textContent = r.getAttribute('data-price');
  var btn = document.querySelector('[data-add]');
  if (btn) {
    var ok = r.getAttribute('data-available') === 'true';
    btn.disabled = !ok;
    btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
  }
});
document.addEventListener('change', function (e) {
  var p = e.target.closest && e.target.closest('[data-purchase]');
  if (!p) return;
  var sub = p.value === 'sub';
  var sel = document.querySelector('[data-plan-select]');
  var wrap = document.querySelector('[data-plan-wrap]');
  if (sel) sel.disabled = !sub;
  if (wrap) wrap.hidden = !sub;
});
document.addEventListener('click', function (e) {
  var t = e.target.closest && e.target.closest('[data-thumb]');
  if (!t) return;
  var main = document.querySelector('[data-gallery-main]');
  if (main) main.setAttribute('src', t.getAttribute('data-thumb'));
});
